import moment from "moment";

/**
 * Establecer un valor para la variable voucher_types (Tipo de comprobante)
 */
export function setVouchersTypes(state, voucher_types) {
    state.voucher_types = voucher_types;
}
/**
 * Establecer un valor para la variable params_voucher_type.branchoffice, que se utiliza para el fecth de voucher_type (Tipo de comprobante)
 * Establecer un valor para la variable params.branch_office. (Tipo de comprobante seleccionado)
 */
export function setBranchOffice(state , branchOffice) {
    state.params_voucher_type.branchoffice = branchOffice;
    state.params.branch_office = branchOffice;
}
/**
 * Establecer un valor para la variable branchOffices (Sedes)
 */
export function setBranchOffices(state , branchOffices) {
    state.branchOffices = branchOffices;
}
/**
 * Establecer un valor para la variable contacts (Terceros)
 */
export function setContacts(state, contacts){
    state.contacts = contacts;
}
/**
 * Establecer un valor para la variable loading
 */
export function setLoading(state, loading){
    state.loading = loading
}
/**
 * Establecer un valor para la variable report_data (Información del reporte)
 */
export function setReportData(state,data){
    state.report_data = data;
}

/**
 * Resta una cantidad de meses a una fecha dada
 */
export function subtractMonthsToDate(date, quantity_months) {
    const date_clone = new Date(date);

    // Obtener el mes y año actuales
    const current_month = date_clone.getMonth();
    const current_year = date_clone.getFullYear();

    // Calcular el nuevo mes y año
    let new_month = current_month - quantity_months;
    let new_year = current_year;

    // Manejar el cambio de año si el nuevo mes es menor a 0
    while (new_month < 0) {
        new_month += 12;
        new_year--;
    }

    // Establecer la nueva fecha con los meses restados
    date_clone.setMonth(new_month);
    date_clone.setFullYear(new_year);

    return date_clone;
}

/**
 * Establecer un valor por defecto para las fechas del reporte Primer día del mes anterior - Día en curso
 */
export function setDateRangeParam(state) {

    const date_current = new Date(); // Fecha actual

    // Restar un mes a la fecha actual para obtener el mes anterior
    const date_month_previous = subtractMonthsToDate(date_current, 1);

    // Obtener el primer día del mes anterior
    const first_day_month_previous = new Date(date_month_previous.getFullYear(), date_month_previous.getMonth(), 1);

    // Obtener el último día del mes anterior
    //const ultimoDiaMesAnterior = new Date(date_month_previous.getFullYear(), date_month_previous.getMonth() + 1, 0);

    state.params.date = [
        moment(first_day_month_previous).format('YYYY-MM-DD'),
        moment(date_current).format('YYYY-MM-DD'),
    ];
}
/**
 * Establecer un valor para la variable product_details_document (Productos de un documento)
 */
export function setProductDetailsDocument (state, data) {
    state.product_details_document = data;
}
/**
 * Establecer un valor para la variable document_referrals (Información de la segunda tabla)
 */
export function setDocumentReferrals (state, data) {
    state.document_referrals = data;
}
/**
 * Establecer un valor para la variable product_id_details_document_query (El id del producto cuando el detalle se selecciona desde la cantidad de productos de la remision)
 */
export function setProductIDDetailsDocumentQuery (state, data) {
    state.product_id_details_document_query = data;
}
/**
 * Limipiar los parametros de busqueda de los filtros.
 */
export function clearStateParams (state) {
    //state.params.branch_office = null;
    state.params.voucher_type = null;
    state.params.contact = [];
}
/**
 * Limpiar el voucherType (Cuando se cambia la sede)
 */
export function clearVoucherType (state) {
    state.params.voucher_type = null;
}
/**
 * Establecer un valor para la variable name_pdf (Nombre del pdf que se descarga)
 */
export function setNamePdf(state, name_pdf) {
    state.name_pdf = name_pdf;
}
/**
 * Establecer un valor para la variable column_status (Nombre que se le brinda a columna status)
 */
export function setColumnStatus(state, column) {
    state.column_status = column;
}
/**
 * Establecer un valor para la variable templates (Modelos que se cargan en el select)
 */
export function setTemplates(state , templates) {
    state.templates = templates;
}

/**
 * Establecer un valor para la variable template (Modelo seleccionado en el template)
 */
export function setTemplate(state , template) {
    state.params.template = template;
}


// WEBPACK FOOTER //
// ./src/modules/report-sales-referrals/mutations.js